import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("uncloned_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const path = window.location.pathname;
            if (!path.startsWith("/login") && !path.startsWith("/signup") && path !== "/") {
                localStorage.removeItem("uncloned_token");
                localStorage.removeItem("uncloned_user");
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    },
);
